import { useCustomReducer } from '../../../../../base/customHooks'
import IPButton from '../../../../../components/IPButton'
import { useEffect, useMemo, useState } from 'react'
import '../../AccountSummary/AccountSummary.scss'
import Swal from 'sweetalert2'
import InputCampaign from '../../../../../components/InputCampaign'
import { ISelectOption } from '../../../../../components/IPSelectBox/IPSelectBox'
import { exportToXLSX, exportToXLSXVDF, formatDate } from '../../../../../base/utils/dataHelper'
import { BaseComponentWithContextProps, componentWithContext } from '../../../../../base/customHooks/componentHOC'
import IPExcelButton from '../../../../../components/IPExcelButton'
import Table from '../../../../../components/Table'
import { GetVodafonePKRequest, GetVodafonePKResponse } from '../models/model'
import { GetPKListApi } from '../services/getPKListApi'
import '../../AccountSummary/AccountSummary.scss'
import moment from 'moment'

interface IVodafonePKState {
  selectedCompany?: ISelectOption[]
  selectedStatus?: ISelectOption
  companyOptions: ISelectOption[]
  imei?: string
  fi?: string
  vdfurun?: string
  urunKodu?: string
  donem?: string
}

function VodafonePKReport(props: BaseComponentWithContextProps) {
  const getInitialState = (): IVodafonePKState => {
    return {
      companyOptions: []
    }
  }

  const intialState = getInitialState()
  const [state, setState] = useCustomReducer<IVodafonePKState>(intialState)
  const [pkData, setPkData] = useState<GetVodafonePKResponse[]>([])

  const [startDate, setStartDate] = useState(undefined)
  const [endDate, setEndDate] = useState(undefined)
  const toDateTimeLocal = date => {
    return date
      ?.toLocaleString('sv-SE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
      ?.replace(' ', 'T')
  }

  const getDate = async (data: any, title: string) => {
    if (title === 'Start') setStartDate(data)
    else setEndDate(data)
  }

  const [currentPage, setCurrentPage] = useState(0)

  useEffect(() => {
    getPK()
  }, [])

  const getPK = async () => {
    const req: GetVodafonePKRequest = {
      AktivasyonStartDate: startDate && formatDate(startDate),
      AktivasyonEndDate: endDate && formatDate(endDate),
      Imei: state.imei,
    }
    props.showLoading()
    const getPoDoc: GetPKListApi = new GetPKListApi({})
    getPoDoc
      .getPKList(req)
      .then(result => {
        if (result) {
          setPkData(result)
          if (result.length === 0) {
            Swal.fire({
              icon: 'warning',
              title: 'PK verisi bulunamadı',
              showConfirmButton: true,
              allowOutsideClick: false,
            })
          }
          props.hideLoading()
        } else {
          console.warn('PK result is empty.')
          props.hideLoading()
        }
      })
      .catch((err: any) => {
        if (!err.description || err.description === 'OK') {
          props.hideLoading()
          Swal.fire({
            icon: 'error',
            title: 'PK verisi bulunamadı',
            showConfirmButton: true,
            allowOutsideClick: false,
          })
        } else {
          props.hideLoading()
          Swal.fire({
            icon: 'error',
            title: err.description,
            showConfirmButton: true,
            allowOutsideClick: false,
          })
        }
      })
    return
  }

  // Tablo başlıkları
  const columnDefinitions = [
    { Header: 'IMEI', accessor: 'imei' },
    { Header: 'Aktivasyon Tarihi', accessor: 'aktivasyonTarihi' },
    { Header: 'Ödeme Tarihi', accessor: 'odemeTarihi' },
    { Header: 'VDF Bayi Kodu', accessor: 'vdfBayiKodu' },
    { Header: 'Alt Bayi Kod Aralığı', accessor: 'altBayiKodAraligi' },
    { Header: 'Marka', accessor: 'marka' },
    { Header: 'Model', accessor: 'model' },
    { Header: 'Ürün Açıklaması', accessor: 'urunAciklamasi' },
    { Header: 'VDF Ürün Kodu', accessor: 'vdfUrunKodu' },
    { Header: 'CCB Kodu', accessor: 'ccbKodu' },
    { Header: 'EAN Kodu', accessor: 'eanKodu' },
    {
      Header: 'Tutar',
      accessor: 'tutar',
      Cell: ({ value }) => <div style={{ textAlign: 'right' }}>{value}</div>,
    },
    { Header: 'Durum', accessor: 'status' },

  ]

  const tableColumns = useMemo(() => columnDefinitions, [])

  const tableDataAndTotal = useMemo(() => {
    const tableData = pkData.map((item, index) => {
      const data = {
        imei: item.IMEI,
        aktivasyonTarihi: item.AKTIVASYON_TARIHI ? moment(item.AKTIVASYON_TARIHI).format('DD.MM.YYYY') : "-",
        vdfBayiKodu: item.VDF_BAYI_KODU,
        altBayiKodAraligi: item.ALT_BAYI_KOD,
        marka: item.MARKA,
        model: item.MODEL,
        tutar: item.TUTAR,
        odemeTarihi: item.ODEME_TARIHI ? moment(item.ODEME_TARIHI).format('DD.MM.YYYY') : "-",
        urunAciklamasi: item.URUN_ACIKLAMASI,
        vdfUrunKodu: item.VDF_URUN_KODU,
        ccbKodu: item.CCB_KODU,
        eanKodu: item.EAN_KODU,
        status: item.ODEME_DURUMU == "KONTRAT YAPILDI" ? (<span style={{ color: 'green' }}>AKTİVASYON YAPILDI</span>) : (<span style={{ color: 'red' }}>AKTİVASYON BEKLENİYOR</span>),
        //status: item.TUTAR?.length > 0 ? (<span style={{ color: 'red' }}>Aktivasyon Bekleniyor</span>) : (<span style={{ color: 'green' }}>Aktivasyon Yapıldı</span>),
      }
      return data
    })
    return {
      tableData,
    }
  }, [pkData])

  const excelButton = async () => {
    try {
      if (pkData) {
        const data: any[] = []
        if (pkData.length > 0) {
          pkData.map((item, index) => {
            return data.push({
              IMEI: item.IMEI,
              'AKTİVASYON TARİHİ': item.AKTIVASYON_TARIHI ? moment(item.AKTIVASYON_TARIHI).format('DD.MM.YYYY') : "-",
              'ÖDEME TARİHİ': item.ODEME_TARIHI ? moment(item.ODEME_TARIHI).format('DD.MM.YYYY') : "-",
              'VDF BAYI KODU': item.VDF_BAYI_KODU,
              'Alt BAYI KODU': item.ALT_BAYI_KOD,
              MARKA: item.MARKA,
              MODEL: item.MODEL,
              TUTAR: item.TUTAR,
              'ÜRÜN AÇIKLAMASI': item.URUN_ACIKLAMASI,
              'VDF ÜRÜN KODU': item.VDF_URUN_KODU,
              'CCB KODU': item.CCB_KODU,
              'EAN KODU': item.EAN_KODU,
              'ÖDEME DURUMU': item.ODEME_DURUMU == "KONTRAT YAPILDI" ? 'AKTİVASYON YAPILDI' : 'AKTİVASYON BEKLENİYOR',
              //DURUM: item.TUTAR?.length > 0 ? 'Aktivasyon Bekleniyor' : 'Aktivasyon Yapıldı',
            })
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Excele atılacak veri bulunmamaktadır.',
            allowOutsideClick: true,
            backdrop: true,
          })
          return
        }
        exportToXLSXVDF(data, 'Peşine Kontrat Raporu', 'H')
      }
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err.description,
        allowOutsideClick: true,
        backdrop: true,
      })
    }
  }

  return (
    <div className='Reports'>
      <div className='heading-text d-flex justify-content-between align-items-center'>
        <h4 style={{ textAlign: 'center' }}>Peşine Kontrat Raporu</h4>
        <div className='d-flex align-items-center'>
          <IPExcelButton onClick={excelButton} />
        </div>
      </div>
      <form>
        <div className='form-row' style={{ display: 'flex', justifyContent: 'center' }}>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='text'
              id='IMEI'
              name='IMEI'
              label={'IMEI'}
              value={state.imei}
              onChange={e => setState({ imei: e.target.value })}
              isActive
            />
          </div>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='date'
              id='StartDate'
              name='StartDate'
              label={'Aktivasyon Başlangıç Tarihi'}
              value={toDateTimeLocal(startDate)}
              onChange={e => getDate(e.target.value, 'Start')}
              isActive
            />
          </div>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='date'
              id='EndDate'
              name='EndDate'
              label={'Aktivasyon Bitiş Tarihi'}
              value={toDateTimeLocal(endDate)}
              onChange={e => getDate(e.target.value, 'End')}
              isActive
            />
          </div>
        </div>
        <div className='form-row' style={{ display: 'flex', justifyContent: 'center' }}>
          <div className='form-group col-md-3' style={{ justifyContent: 'center', display: 'flex' }}>
            <IPButton
              text='Listele'
              className='button'
              onClick={() => getPK()}
              style={{
                backgroundColor: 'red',
                color: 'white',
                borderRadius: '10px',
                width: '150px',
                height: '50px',
              }}
            />
          </div>
        </div>
      </form>
      <div className='m-4'>
        <Table
          columns={tableColumns}
          data={tableDataAndTotal.tableData}
          currentPage={currentPage}
          onPageChange={setCurrentPage}
          columnCount={13}
          backgroundColor='red'
          color='white'
        />
      </div>
    </div>
  )
}
export default componentWithContext(VodafonePKReport)
